import { React, useEffect, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Radio } from "antd";
import warning from "../../../Assets/Icons/warning.png";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { ModalPopup } from "../../../Components/Modal/modal";
import { Collapse } from 'antd';
import { getUnitData } from "../../../Services/measurementService";
import { weightUnit, weight_Unit_Conversions, orderDim_Rewinder_Unit_Conversion, conversionFactorUnitsToTonne, conversionFactorTonneToUnits, CoversionFactorUnitsToCM, lengthUnit } from "../../../Utils/Constant/MeasurementUnitList";
import { getProcessedQtyDetails } from "../../../Services/orderServices";
import { toHandlePOName } from "../../../Utils/helper/helper";

const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;

const ViewProcessedQuantityDrawer = (props) => {

    const [form] = Form.useForm();
    const [processedQtyData, setProcessedQtyData] = useState();

    useEffect(() => {
        (async () => {
      try{
        const data = await getProcessedQtyDetails(props.selectedOrderNo);
        if (!data.error) {
            setProcessedQtyData(data.data);
        }
      } catch(error) {
        console.log(error);
      }
    })();
    }, [props]);
    
    const handleClose = () => {
      form.resetFields();
      props.onCloseGrade();
    };

    return ( processedQtyData ?
      (<RightDrawerSidebar
      title={`Processed Quantity Details`}
      subtitle=""
      visible={props.visible}
      onClose={handleClose}
      >
        <RightDrawerContainer>
          <div className="resetPassForm removePadLeft">
            <DetailFields className="marginBtnP">
              <HaberForm>
                <Form
                      name="basic"
                      autoComplete="off"
                      className="haberLogin haberSignup"
                      style={{ marginTop: "5px" }}
                      // onFinish={onFinish}
                      form={form}
                    >
                      <div className="drawerField" style={{paddingTop:"0px", marginTop: "-9px"}}>
                        <div className="titleWithText">
                          <h5>Order Details</h5>
                          {processedQtyData.category==='so'?
                           <p style={{ marginBottom: "0px" }}>
                           Stock Order :{" "}{toHandlePOName(processedQtyData?.so)}
                       </p>
                            :
                            <p style={{ marginBottom: "0px" }}>
                            Purchase Order :{" "}{toHandlePOName(processedQtyData.po)}
                        </p>
                            }
                          {" "}
                          <p style={{ marginBottom: "0px" }}>
                            Order Number :{" "}{processedQtyData.id}
                          </p>
                          <p style={{ marginBottom: "0px" }}>
                            Size : {""}{processedQtyData.type == "sheet" ? (processedQtyData?.length + " " + (lengthUnit[processedQtyData?.units?.length]?.displayName)?.toUpperCase() + " x " + processedQtyData?.width + " " + (lengthUnit[processedQtyData?.units?.width]?.displayName)?.toUpperCase()) : (processedQtyData?.width + " " + (lengthUnit[processedQtyData?.units?.width]?.displayName)?.toUpperCase())}
                          </p>
                          <p>Order Quantity :{" "}{processedQtyData.quantity_type == "reel_sheet" ? (processedQtyData.no_of_reel_sheet + " " + processedQtyData.type + "s") : 
                          (processedQtyData.weight?.toFixed(3) + " " + capitalize(weightUnit[processedQtyData?.units?.weight]?.displayName))} </p>
                        </div>
                      </div>
                      <div className="drawerField">
                        <div className="titleWithText">
                          <h5>Total Processed Quantity</h5>
                          <p>Planned Quantity details of this item </p>
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={13}>
                                <div className="boxFormType">
                                  <Form.Item
                                  name="processed_quantity"
                                  initialValue={(processedQtyData.type == "reel" && processedQtyData.quantity_type == "reel_sheet") ? 
                                  processedQtyData.total_processed_quantity.quantity : parseFloat(processedQtyData?.total_processed_quantity?.weight)?.toFixed(3) }
                                  className=""
                                  >
                                    <Input
                                    disabled={true}
                                />
                                  </Form.Item>
                                </div>
                              </Col>
                              {(processedQtyData?.type == "reel" && processedQtyData?.quantity_type == "reel_sheet") ? (
                                <Col span={10}>
                                  <div className="boxFormType ">
                                  <Form.Item
                                  name="reelUnit"
                                  initialValue={"reels"}
                                  className="dBlock"
                                >
                                  <Select
                                    suffixIcon={<DownArrowDraw />}
                                    disabled={true}
                                  >
                                  </Select>
                                  </Form.Item>
                                </div>
                                </Col>
                              ) : (
                              <Col span={10}>
                                <div className="boxFormType ">
                                  <Form.Item
                                  name="processed_quantity_unit"
                                  initialValue={capitalize(weightUnit[processedQtyData?.units?.total_processed_quantity]?.displayName)}
                                  className="dBlock"
                                >
                                  <Select
                                    suffixIcon={<DownArrowDraw />}
                                    disabled={true}
                                  >
                                  </Select>
                                  </Form.Item>
                                </div>
                              </Col>)}
                            </Row>
                            </div>
                          </>
                        </div>
                      </div>
                      <div className="drawerField">
                        <div className="titleWithText">
                          <h5>Quantity planned to be produced</h5>
                          <p>Quantity matched in job cards that are yet to be produced</p>
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                              <Row className="centerAlign justifyCSBetween">
                                <Col span={13}>
                                  <div className="boxFormType">
                                    <Form.Item
                                    name="planned_quantity"
                                    initialValue={(processedQtyData.type == "reel" && processedQtyData.quantity_type == "reel_sheet") ? 
                                    processedQtyData.quantity_planned_to_be_produced.quantity : parseFloat(processedQtyData?.quantity_planned_to_be_produced?.weight)?.toFixed(3) }
                                    className=""
                                    >
                                      <Input
                                      disabled={true}
                                  />
                                    </Form.Item>
                                  </div>
                                </Col>
                                {(processedQtyData?.type == "reel" && processedQtyData?.quantity_type == "reel_sheet") ? (
                                  <Col span={10}>
                                    <div className="boxFormType ">
                                    <Form.Item
                                    name="reelUnit"
                                    initialValue={"reels"}
                                    className="dBlock"
                                  >
                                    <Select
                                      suffixIcon={<DownArrowDraw />}
                                      disabled={true}
                                    >
                                    </Select>
                                    </Form.Item>
                                  </div>
                                  </Col>
                                ) : (
                                <Col span={10}>
                                  <div className="boxFormType ">
                                    <Form.Item
                                    name="produced_unit"
                                    initialValue={capitalize(weightUnit[processedQtyData?.units?.quantity_planned_to_be_produced]?.displayName)}
                                    className="dBlock"
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      disabled={true}
                                    >
                                    </Select>
                                    </Form.Item>
                                  </div>
                                </Col>)}
                              </Row>
                              <Row className="centerAlign justifyCSBetween">
                              {processedQtyData?.type == "reel" && 
                              processedQtyData?.multiple_diameter_data?.map((item) => {
                                return(
                                    // <p>Reel OD: {""}{item.reel_od} {"  |  "} Core OD: {""}{item.core_id} {""}{""}{""}
                                    // <span style={{marginLeft: "20px"}}>Quantity: {""}{(item.in_process_weight + item.on_hold_weight)?.toFixed(3)}{""}{capitalize(weightUnit[processedQtyData?.units?.quantity_planned_to_be_produced]?.displayName)}
                                    // {"  |  "} {item.in_process + item.on_hold}{" reels"}</span></p>
                                    <div className="titleWithText">
                                        <p style={{ marginBottom: "0px" }}>Reel OD: {""}{item.reel_od} {"  |  "} Core OD: {""}{item.core_id}</p>
                                        <p style={{ marginBottom: "2px" }}>Quantity: {""}{(item.in_process_weight + item.on_hold_weight)?.toFixed(3)}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_planned_to_be_produced]?.displayName)}
                                        {"  |  "} {item.in_process + item.on_hold}{" reels"}</p>
                                    </div>
                                )})
                              }
                              {processedQtyData?.type == "sheet" &&
                                  <> 
                                  {/* style={{borderBottom: "1px solid #edebe9"}} */}
                                    {/* <p>Intermediate Reels: {""}{processedQtyData?.quantity_planned_to_be_produced?.intermediate_reels["weight"]}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_planned_to_be_produced]?.displayName)} {"  |  "} 
                                    {processedQtyData?.quantity_planned_to_be_produced?.intermediate_reels["quantity"]}{" Sheets"}
                                    </p>
                                    <p>Cutting Plan: {""}{processedQtyData?.quantity_planned_to_be_produced?.cutting_plan["weight"]}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_planned_to_be_produced]?.displayName)} {"  |  "} 
                                    {processedQtyData?.quantity_planned_to_be_produced?.cutting_plan["quantity"]}{" Sheets"}
                                    </p> */}
                                   <div className="titleWithText">
                                   <p style={{ marginBottom: "0px" }}>Intermediate Reels: {""}{processedQtyData?.quantity_planned_to_be_produced?.intermediate_reels["weight"]}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_planned_to_be_produced]?.displayName)} {"  |  "} 
                                    {processedQtyData?.quantity_planned_to_be_produced?.intermediate_reels["quantity"]}{" Sheets"}</p>
                                    <p style={{ marginBottom: "2px" }}>Cutting Plan: {""}{processedQtyData?.quantity_planned_to_be_produced?.cutting_plan["weight"]}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_planned_to_be_produced]?.displayName)} {"  |  "} 
                                    {processedQtyData?.quantity_planned_to_be_produced?.cutting_plan["quantity"]}{" Sheets"}</p>
                                   </div>
                                  </>
                              }
                              </Row>
                            </div>
                          </>
                        </div>
                      </div>
                      <div className="drawerField">
                        <div className="titleWithText">
                          <h5>Quantity in production</h5>
                          <p>Quantity matched in job cards that are in production</p>
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                              <Row className="centerAlign justifyCSBetween">
                                <Col span={13}>
                                  <div className="boxFormType">
                                    <Form.Item
                                    name="production_quantity"
                                    initialValue={(processedQtyData.type == "reel" && processedQtyData.quantity_type == "reel_sheet") ? 
                                    processedQtyData.quantity_in_production.quantity : parseFloat(processedQtyData?.quantity_in_production?.weight)?.toFixed(3) }
                                    className=""
                                    >
                                      <Input
                                      disabled={true}
                                  />
                                    </Form.Item>
                                  </div>
                                </Col>
                                {(processedQtyData?.type == "reel" && processedQtyData?.quantity_type == "reel_sheet") ? (
                                    <Col span={10}>
                                      <div className="boxFormType ">
                                      <Form.Item
                                      name="prodUnit"
                                      initialValue={"reels"}
                                      className="dBlock"
                                    >
                                      <Select
                                        suffixIcon={<DownArrowDraw />}
                                        disabled={true}
                                      >
                                      </Select>
                                      </Form.Item>
                                    </div>
                                    </Col>
                                  ) : (
                                  <Col span={10}>
                                    <div className="boxFormType ">
                                      <Form.Item
                                      name="prod_unit"
                                      initialValue={capitalize(weightUnit[processedQtyData?.units?.quantity_in_production]?.displayName)}
                                      className="dBlock"
                                    >
                                      <Select
                                        placeholder="Unit"
                                        suffixIcon={<DownArrowDraw />}
                                        disabled={true}
                                      >
                                      </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>)}
                              </Row>
                              <Row className="centerAlign justifyCSBetween">
                              {processedQtyData?.type == "reel" && 
                                processedQtyData?.multiple_diameter_data?.map((item) => {
                                  return(
                                      // <p>Reel OD: {""}{item.reel_od} {"  |  "} Core OD: {""}{item.core_id} {""}{""}{""}
                                      // <span style={{marginLeft: "20px"}}>Quantity: {""}{(item.in_production_weight)?.toFixed(3)}{""}{capitalize(weightUnit[processedQtyData?.units?.quantity_in_production]?.displayName)}
                                      // {"  |  "} {item.in_production}{" reels"}</span></p>
                                      <div className="titleWithText">
                                        <p style={{ marginBottom: "0px" }}>
                                        Reel OD: {""}{item.reel_od} {"  |  "} Core OD: {""}{item.core_id}
                                        </p>
                                        {" "}
                                        <p style={{ marginBottom: "2px" }}>
                                        Quantity: {""}{(item.in_production_weight)?.toFixed(3)}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_in_production]?.displayName)}
                                        {"  |  "} {item.in_production}{" reels"}
                                        </p>
                                      </div>
                                  )})
                                }
                                {processedQtyData?.type == "sheet" &&
                                  <> 
                                  {/* style={{borderBottom: "1px solid #edebe9"}} */}
                                    {/* <p>Intermediate Reels: {""}{processedQtyData?.quantity_in_production?.intermediate_reels["weight"]}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_in_production]?.displayName)} {"  |  "} 
                                    {processedQtyData?.quantity_in_production?.intermediate_reels["quantity"]}{" Sheets"}
                                    </p>
                                    <p>Cutting Plan: {""}{processedQtyData?.quantity_in_production?.cutting_plan["weight"]}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_in_production]?.displayName)} {"  |  "} 
                                    {processedQtyData?.quantity_in_production?.cutting_plan["quantity"]}{" Sheets"}
                                    </p> */}
                                    <div className="titleWithText">
                                        <p style={{ marginBottom: "0px" }}>
                                        Intermediate Reels: {""}{processedQtyData?.quantity_in_production?.intermediate_reels["weight"]}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_in_production]?.displayName)} {"  |  "} 
                                    {processedQtyData?.quantity_in_production?.intermediate_reels["quantity"]}{" Sheets"}
                                        </p>
                                        {" "}
                                        <p style={{ marginBottom: "2px" }}>
                                        Cutting Plan: {""}{processedQtyData?.quantity_in_production?.cutting_plan["weight"]}{" "}{capitalize(weightUnit[processedQtyData?.units?.quantity_in_production]?.displayName)} {"  |  "} 
                                    {processedQtyData?.quantity_in_production?.cutting_plan["quantity"]}{" Sheets"}
                                        </p>
                                      </div>
                                  </>
                              }
                              </Row>
                            </div>
                          </>
                        </div>
                      </div>
                      <div className="drawerField">
                        <div className="titleWithText">
                          <h5>Produced Quantity</h5>
                          <p>Quantity which is produced</p>
                          <>
                            <div className="subTitleWithText">
                              <p></p>
                            </div>
                            <div style={{ position: "relative" }}>
                              <Row className="centerAlign justifyCSBetween">
                              <Col span={13}>
                                <div className="boxFormType">
                                  <div className="boxFormType">
                                    <Form.Item
                                    name="produced_quantity"
                                    initialValue={(processedQtyData.type == "reel" && processedQtyData.quantity_type == "reel_sheet") ? 
                                    processedQtyData.produced_quantity.quantity : parseFloat(processedQtyData?.produced_quantity?.weight)?.toFixed(3) }
                                    className=""
                                    >
                                      <Input
                                      disabled={true}
                                    />
                                    </Form.Item>
                                  </div>
                                </div>
                              </Col>
                              {(processedQtyData?.type == "reel" && processedQtyData?.quantity_type == "reel_sheet") ? (
                                    <Col span={10}>
                                      <div className="boxFormType ">
                                      <Form.Item
                                      name="producedQtyUnit"
                                      initialValue={"reels"}
                                      className="dBlock"
                                    >
                                      <Select
                                        suffixIcon={<DownArrowDraw />}
                                        disabled={true}
                                      >
                                      </Select>
                                      </Form.Item>
                                    </div>
                                    </Col>
                                  ) : (
                                  <Col span={10}>
                                    <div className="boxFormType ">
                                      <Form.Item
                                      name="producedQty_unit"
                                      initialValue={capitalize(weightUnit[processedQtyData?.units?.produced_quantity]?.displayName)}
                                      className="dBlock"
                                    >
                                      <Select
                                        placeholder="Unit"
                                        suffixIcon={<DownArrowDraw />}
                                        disabled={true}
                                      >
                                      </Select>
                                      </Form.Item>
                                    </div>
                                  </Col>)}
                              </Row>
                              <Row className="centerAlign justifyCSBetween">
                              {processedQtyData?.type == "reel" && 
                                processedQtyData?.multiple_diameter_data?.map((item) => {
                                  return(
                                      // <p>Reel OD: {""}{item.reel_od} {"  |  "} Core OD: {""}{item.core_id} {""}{""}{""}
                                      // <span style={{marginLeft: "20px"}}>Quantity: {""}{(item.completed_weight)?.toFixed(3)}{""}{capitalize(weightUnit[processedQtyData?.units?.produced_quantity]?.displayName)}
                                      // {"  |  "} {item.completed}{" reels"}</span></p>
                                      <div className="titleWithText">
                                        <p style={{ marginBottom: "0px" }}>
                                        Reel OD: {""}{item.reel_od} {"  |  "} Core OD: {""}{item.core_id}
                                        </p>
                                        {" "}
                                        <p style={{ marginBottom: "2px" }}>
                                        Quantity: {""}{(item.completed_weight)?.toFixed(3)}{" "}{capitalize(weightUnit[processedQtyData?.units?.produced_quantity]?.displayName)}
                                        {"  |  "} {item.completed}{" reels"}
                                        </p>
                                      </div>
                                  )})
                                }
                                {processedQtyData?.type == "sheet" &&
                                  <> 
                                  {/* style={{borderBottom: "1px solid #edebe9"}} */}
                                    <p>{processedQtyData?.produced_quantity?.["weight"]}{" "}{capitalize(weightUnit[processedQtyData?.units?.produced_quantity]?.displayName)} {"  |  "} 
                                    {processedQtyData?.produced_quantity?.["quantity"]}{" Sheets"}
                                    </p>
                                  </>
                              }
                              </Row>
                            </div>
                          </>
                        </div>
                      </div>
                </Form>
              </HaberForm>
            </DetailFields>
          </div>
        </RightDrawerContainer>
      </RightDrawerSidebar>) : (
        null
      )
    );

};
export default ViewProcessedQuantityDrawer;